import 'flag-icons/css/flag-icons.min.css';

interface SessionCountryProps {
  code: string;
  name?: string;
}

export function SessionCountry({ code, name }: SessionCountryProps) {
  if (!name) return code || null;

  return (
    <span>
      <span className={`fi fi-${code.toLowerCase()} me-1.5`} aria-hidden />
      {name}
    </span>
  );
}
